
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.064","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M15.107 0a2.3 2.3 0 011.035.7c1.184 1.191 2.376 2.376 3.56 3.567a1.964 1.964 0 00.22.156c-.1.106-.149.163-.206.213C18.354 5.998 17 7.359 15.631 8.714a.515.515 0 01-.319.149q-4.851.011-9.709.007c-.043 0-.092-.007-.177-.007.057-.071.1-.121.142-.17q4.117-4.117 8.234-8.22a3.8 3.8 0 01.773-.468zM24.065 9.468a2.471 2.471 0 01-.738 1.064c-.56.546-1.106 1.106-1.723 1.723a3.135 3.135 0 00-.738-2.468c.73-.738 1.447-1.454 2.177-2.191a3.112 3.112 0 011.021 1.348zM20.9 5.525c.347.348.716.709 1.113 1.106-.128.113-.27.234-.4.362-.617.617-1.234 1.227-1.844 1.851a.353.353 0 01-.348.106c-.39-.05-.78-.071-1.17-.085-.234-.014-.461 0-.688 0zM20.255 11.709a1.428 1.428 0 00-1.546-1.56H1.56A1.428 1.428 0 000 11.695V22.44A1.428 1.428 0 001.567 24H18.7a1.428 1.428 0 001.56-1.567zM5.028 20.922H2.262v-1.383h2.766zm4.326 0H6.582v-1.39h2.773zm4.3 0h-2.76v-1.383h2.766zm4.319 0H15.22v-1.383h2.759zm-1.248-4.617a1.482 1.482 0 111.482-1.482 1.482 1.482 0 01-1.476 1.482z"}})])
          )
        }
      }
    